import { Axios } from '@utils/api/axios-instance';
import { useMutation, UseMutationResult } from 'react-query';
import { TokenExtension } from '@utils/extensions/token.extension';

interface UploadAlignmentPayload {
  sessionId: string;
  mediaFile: File;
  transcriptFile: File;
  onProgress?: (progress: number) => void;
}

interface AlignmentUploadResponse {
  session_id: string;
  status: string;
  status_code: number;
  session_mode: string;
  language: string;
  filename?: string;
  duration?: number;
  date_create: string;
  date_upload?: string;
}

const uploadAlignment = async (
  payload: UploadAlignmentPayload
): Promise<AlignmentUploadResponse> => {
  const authToken = TokenExtension.get();
  const formData = new FormData();

  formData.append('media_file', payload.mediaFile);
  formData.append('transcript_file', payload.transcriptFile);

  const response = await Axios.post<AlignmentUploadResponse>(
    `/api/v3/speech-to-text/session/${payload.sessionId}/align`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${authToken.string}`,
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: progressEvent => {
        if (progressEvent.total && payload.onProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          payload.onProgress(percentCompleted);
        }
      }
    }
  );

  return response.data;
};

export const useUploadAlignment = (): UseMutationResult<
  AlignmentUploadResponse,
  Error,
  UploadAlignmentPayload
> => {
  return useMutation(uploadAlignment);
};
